import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { EtapaRastreio } from 'src/app/models/etapa-rastreio';
import { CarregandoService } from 'src/app/services/carregando.service';
import { EtapaRastreioService } from 'src/app/services/etapa-rastreio.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { IconesModalComponent } from '../icones-modal/icones-modal.component';
import { CRMTag } from 'src/app/models/crm/crmtag';

declare const $: any;

@Component({
  selector: 'app-cadastrar-etapa-rastreio-modal',
  templateUrl: './cadastrar-etapa-rastreio-modal.component.html',
  styleUrls: ['./cadastrar-etapa-rastreio-modal.component.scss']
})
export class CadastrarEtapaRastreioModalComponent implements OnInit {
  idEtapa: number;
  etapa: EtapaRastreio = new EtapaRastreio();
  situacao = [{ id: 1, descricao: 'Ativo' }, { id: 0, descricao: 'Inativo' }];
  situacaoSelecionada: number = 1;
  public config: PerfectScrollbarConfigInterface = {};
  editando: boolean;
  enumInterna = [{ id: 1, descricao: 'Aguardando Pagamento', disabled: false }, { id: 2, descricao: 'Aguardando Faturamento', disabled: false }, { id: 3, descricao: 'Aguardando Separação', disabled: false }, { id: 4, descricao: 'Aguardando Transportadora', disabled: false }, { id: 5, descricao: 'Pedido Coletado', disabled: false }, { id: 6, descricao: 'Pedido Entregue', disabled: false }, { id: 0, descricao: 'Nenhum', disabled: false }];
  enumSelecionada = 0;
  tag = new CRMTag();
  ordem: number = 0;
  etapasExistentes: number[] = [];

  constructor(
    public dialogRef: MatDialogRef<CadastrarEtapaRastreioModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private etapaRastreioService: EtapaRastreioService,
    public dialog: MatDialog,
  ) {
    this.idEtapa = data.idEtapa;
    this.ordem = data.ordem;
    this.etapasExistentes = data.etapasExistentes;
  }

  ngOnInit() {
    this.enumInterna.forEach((item) => {
      if (this.etapasExistentes.includes(item.id)) {
        item.disabled = true;
      }
    });

    if ([1, 2, 3, 4, 5, 6].every(enumId => this.etapasExistentes.includes(enumId))) {
      this.enumSelecionada = 0;
    }

    if (this.idEtapa) {
      this.editando = true;
      this.buscar();
    } else {
      this.etapa = new EtapaRastreio();
    }
  }

  recebeDados() {
    this.etapa.ativo = this.situacaoSelecionada;
    this.etapa.icone = this.tag.icone;
    this.etapa.enumInterno = this.enumSelecionada;
    this.etapa.ordem = this.ordem;
  }

  salvar() {
    this.recebeDados();

    this.carregandoService.mostra('salvar');
    this.etapaRastreioService.salvar(this.etapa).subscribe((retorno) => {
      this.notificacaoService.sucesso('Setor salvo com sucesso!!!');
      this.carregandoService.esconde('salvar');
      this.dialogRef.close(this.etapa);
    }, (erro) => {
      this.carregandoService.esconde('salvar');
      this.notificacaoService.erro(erro);
    });
  }

  buscar() {
    this.carregandoService.mostra('buscar');

    this.etapaRastreioService.consultarPorId(this.idEtapa).subscribe((data: any) => {
      this.etapa = data;
      this.tag.icone = this.etapa.icone;
      this.enumSelecionada = this.etapa.enumInterno;
      this.situacaoSelecionada = this.etapa.ativo;
      this.ordem = this.etapa.ordem;

      this.enumInterna.forEach((item) => {
        if (this.etapasExistentes.includes(this.etapa.id)) {
          item.disabled = false;
        }
      });

      this.carregandoService.esconde('buscar');
    }, (erro) => {
      this.carregandoService.esconde('buscar');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarIcone() {
    const dialogRef = this.dialog.open(IconesModalComponent, {
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.tag.icone = result;
      }
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
